import { useMemo, useState } from 'react';
import { Search } from 'lucide-react';
import NavSectionItem from './NavSectionItem';

export default function NavSection({ navConfig = [] }) {
  const [searchText, setSearchText] = useState('');

  const filteredGroups = useMemo(() => {
    if (!searchText.trim()) return navConfig;

    const query = searchText.toLowerCase();
    return navConfig
      .map((group) => ({
        ...group,
        items: group.items.filter((item) => item.title.toLowerCase().includes(query)),
      }))
      .filter((group) => group.items.length > 0);
  }, [searchText, navConfig]);

  const flatResults = useMemo(() => {
    if (!searchText.trim()) return null;
    return navConfig
      .flatMap((group) => group.items)
      .filter((item) => item.title.toLowerCase().includes(searchText.toLowerCase()));
  }, [searchText, navConfig]);

  return (
    <div className="sidebar-nav">
      <div className="sidebar-nav__search">
        <Search className="sidebar-nav__search-icon text-muted" size={18} />
        <input
          type="text"
          placeholder="Search menu..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          aria-label="Search menu"
        />
      </div>

      <nav className="sidebar-nav__menu" aria-label="Admin sections">
        {flatResults
          ? flatResults.map((item) => <NavSectionItem key={item.path} data={item} />)
          : filteredGroups.map((group) => (
              <div key={group.label} className="sidebar-nav__group">
                <p className="sidebar-nav__group-label">{group.label}</p>
                {group.items.map((item) => (
                  <NavSectionItem key={item.path} data={item} />
                ))}
              </div>
            ))}
      </nav>
    </div>
  );
}
